import { createEvent, createStore, createEffect, sample } from 'effector';

const ATTENTION_ANIMATION_DURATION = 500; //ms

function wait(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

const attentionAnimationTimeoutFx = createEffect(`ClientLayoutTimer`).use(() => wait(ATTENTION_ANIMATION_DURATION));

interface ClientLayoutStore {
  playCentralPartAttentionAnimation: boolean;
}

/**
 * Plays an animation on client layout layout to bring user attention
 */
export const bringAttentionToCentralPartEvent = createEvent();
const removeAttentionFromCentralPartEvent = createEvent();

export const $clientLayout = createStore<ClientLayoutStore>({
  playCentralPartAttentionAnimation: false,
});

$clientLayout.on(bringAttentionToCentralPartEvent, (state) => {
  return {
    ...state,
    playCentralPartAttentionAnimation: true,
  };
});

$clientLayout.on(removeAttentionFromCentralPartEvent, (state) => {
  return {
    ...state,
    playCentralPartAttentionAnimation: false,
  };
});

sample({
  clock: bringAttentionToCentralPartEvent,
  target: attentionAnimationTimeoutFx,
});

sample({
  source: attentionAnimationTimeoutFx.done,
  target: removeAttentionFromCentralPartEvent,
});
